import api from './api';

export interface IContactPayload {
  fullName: string;
  email: string;
  phone: string;
  subject: string;
  message: string;
}

export const submitContactForm = async (payload: IContactPayload) => {
  try {
    const response = await api.post('/contact/send', payload);
    return response.data;
  } catch (error: any) {
    if (error.response && error.response.data && error.response.data.message) {
      throw new Error(error.response.data.message);
    }
    throw new Error('An unknown error occurred while submitting your message.');
  }
};